<template>
  <v-container>
    <v-btn
      color="secondary"
      class="ml-4"
      @click="
        () => {
          this.$router.push('faturar');
        }
      "
      >Faturamento</v-btn
    >

    <v-flex xs12 style="padding-left: 20px">
      <p>Buscar por período:</p>
    </v-flex>
    <v-layout style="padding-left: 20px">
      <v-flex xs12 sm6 md3 v-if="this.user.group.indexOf('admin') >= 0">
        <v-combobox
          @change="getPartnerOperations()"
          style="padding-right: 10px"
          box
          v-model="partner"
          :items="partners"
          label="Parceiros"
        ></v-combobox>
      </v-flex>
      <div v-else></div>
      <v-flex xs12 sm6 md3>
        <v-text-field
          style="padding-right: 10px"
          label="Data de Inicio"
          v-model="startDate"
          mask="##/##/####"
          box
        ></v-text-field>
      </v-flex>
      <span style="padding-top: 20px">Até</span>
      <v-flex xs12 sm6 md3>
        <v-text-field
          height="50"
          style="padding-left: 10px; padding-right: 20px"
          label="Data de Fim"
          v-model="endDate"
          mask="##/##/####"
          box
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-btn color="success" @click="clickBuscar">Buscar</v-btn>
      </v-flex>
    </v-layout>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="text-xs-center" v-if="listError">
      Não conseguimos carregar os extratos. Por favor atualize a página. Caso o
      problema persistir, contate nosso time.
    </div>
    <div v-else-if="operations.length == 0" class="text-xs-center">
      Não houve operações neste período.
    </div>
    <v-expansion-panel v-else-if="operations" style="box-shadow: none">
      <v-expansion-panel-content
        v-for="(operation, i) in operations"
        :key="i"
        style="background-color: #efefef; border: none"
        @click.native="showDetails($event, i)"
      >
        <template v-slot:header v-if="operation && operation.date">
          <div>
            <span
              style="
                padding: 10px;
                font-weight: bold;
                background: #343a40;
                color: white;
                border-radius: 5px;
              "
              >{{ getDayMonth(operation.date) }}</span
            >
          </div>
          <div>{{ getDayName(operation.date) }}</div>
          <div>
            <small>Entrada:</small>
            <span :style="'font-weight: bold; color: #41b781'"
              >R$
              {{
                (operation.available.amount.in - operation.available.fee.in)
                  | formatMoney
              }}</span
            >
          </div>
          <div>
            <small>Saída:</small>
            <span :style="'font-weight: bold; color: #f5494f'"
              >R$
              {{
                (operation.available.amount.out - operation.available.fee.out)
                  | formatMoney
              }}</span
            >
          </div>
          <div>
            <small>Saldo:</small>
            <span :style="'font-weight: bold;'"
              >R$
              {{
                (operation.available.amount.balance -
                  operation.available.fee.balance)
                  | formatMoney
              }}</span
            >
          </div>
        </template>
        <div class="text-xs-center" v-if="loadingDetail">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-card v-else-if="operation.details">
          <v-card-text>
            <div v-for="(detail, j) in operation.details" :key="j">
              <v-layout>
                <!-- tipo de operacao -->
                <v-flex xs6 v-if="detail.movement_object.type == 'refund'"
                  >Estorno</v-flex
                >
                <v-flex xs6 v-else-if="detail.movement_object.type == 'billing'"
                  >Serviço de Gateway</v-flex
                >
                <v-flex xs6 v-else-if="detail.movement_object.type == 'ted'"
                  >Saque</v-flex
                >
                <v-flex
                  xs6
                  v-else-if="detail.movement_object.payment_method == 'boleto'"
                  >Boleto Bancário</v-flex
                >
                <v-flex xs6 v-else>Cartão de Crédito</v-flex>
                <!-- calculo da operacao -->
                <v-flex xs3 v-if="detail.movement_object.type == 'refund'">
                  <span style="color: #f5494f; font-weight: bold"
                    >R$ -{{ detail.amount | formatMoney }}</span
                  >
                  + R$ {{ detail.fee | formatMoney }}
                </v-flex>

                <v-flex xs3 v-else>
                  <span :style="getColorStyle(detail.movement_object.type)"
                    >R$ {{ detail.amount | formatMoney }}</span
                  >
                  - R$ {{ detail.fee | formatMoney }}
                </v-flex>
                <!-- saldo -->
                <v-flex xs3 :style="getColorStyle(detail.movement_object.type)"
                  >R$ {{ (detail.amount - detail.fee) | formatMoney }}</v-flex
                >
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
// import axios from "axios"
// import api from '../utils/api'
import { getPartner } from "../services/partners";
import { getExtrato, getExtratoDetails } from "../services/extrato";
import { mapState } from "vuex";

export default {
  data() {
    return {
      recipient_id: "",
      partners: ["enercred", "safiraenergia", "emap", "alpavi", "wanderbrasil"],
      partner: "enercred",
      startDate: "",
      endDate: "",
      operations: [
        {
          date: "",
          available: {
            fee: {},
            amount: {},
          },
        },
      ],
      loading: false,
      loadingDetail: false,
      listError: false,
    };
  },
  created() {
    this.recipient_id = this.user.recipient_id;

    let date = new Date();
    let day = date.getDate().toString();
    day = day.length == 1 ? "0" + day : day;
    let month = this.getMonthFixed(date);
    let year = date.getFullYear().toString();
    this.endDate = day + month + year;

    date.setMonth(date.getMonth() - 1);
    month = this.getMonthFixed(date);
    this.startDate = day + month + year;

    this.clickBuscar(this.startDate, this.endDate);
  },
  computed: {
    ...mapState(["user"]),
  },
  filters: {
    formatMoney: function (value) {
      if (!value) return value;
      value = value.toString().replace("-", "");
      if (value.length == 1) {
        return "0,0" + value;
      }
      if (value.length == 2) {
        return "0," + value;
      }
      return (
        value.slice(0, value.length - 2) +
        "," +
        value.slice(value.length - 2, value.length)
      );
    },
  },
  methods: {
    getMonthFixed(date) {
      if (date.getMonth() + 1 < 10) {
        return "0" + (date.getMonth() + 1).toString();
      }
      return (date.getMonth() + 1).toString();
    },
    getDayName(date) {
      var days = [
        "Domingo",
        "Segunda-Feira",
        "Terça-Feira",
        "Quarta-Feira",
        "Quinta-Feira",
        "Sexta-Feira",
        "Sábado",
      ];
      var d = new Date(date);
      return days[d.getDay()];
    },
    getDayMonth(date) {
      const operationSplited = date.split("-");
      const day = operationSplited[2].slice(0, 2);
      const month = operationSplited[1];
      const year = operationSplited[0];
      return day + "/" + month + "/" + year;
    },
    getDateTimestamp(date) {
      return new Date(
        date.slice(4),
        date.slice(2, 4) - 1,
        date.slice(0, 2),
      ).getTime();
    },
    clickBuscar() {
      let startDateTimestamp = this.getDateTimestamp(this.startDate);
      let endDateTimestamp = this.getDateTimestamp(this.endDate);
      this.buscar(startDateTimestamp, endDateTimestamp);
    },
    buscar(startDateTimestamp, endDateTimestamp) {
      this.loading = true;
      getExtrato(startDateTimestamp, endDateTimestamp, this.recipient_id)
        .then((res) => {
          this.operations = res.data.reverse();
          this.loading = false;
          this.listError = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
          this.listError = true;
        });
    },
    showDetails(e, index) {
      // eslint-disable-next-line no-undef
      let $target = $(e.target),
        // eslint-disable-next-line no-undef
        $header = $(".v-expansion-panel__header");
      if ($target.is($header) || $target.parents($header).is($header)) {
        this.loadingDetail = true;
        let date = new Date(this.operations[index].date);
        date.setUTCHours(3);
        let startDateTimestamp = date.getTime();
        date.setDate(date.getDate() + 1);
        let endDateTimestamp = date.getTime();
        getExtratoDetails(
          startDateTimestamp,
          endDateTimestamp,
          this.recipient_id,
        )
          .then((res) => {
            this.$set(this.operations[index], "details", res.data.reverse());
            this.loadingDetail = false;
          })
          .catch((err) => {
            console.error(err);
            this.loadingDetail = false;
          });
      }
    },
    getColorStyle(operationType) {
      if (operationType == "refund" || operationType == "billing")
        return "color: #f5494f; font-weight: bold";
      if (operationType == "ted") return "color: #ef6d00; font-weight: bold";
      else return "color: #41b781; font-weight: bold";
    },
    getPartnerOperations() {
      getPartner(this.partner).then((partner) => {
        this.recipient_id = partner.data.recipient_id;
        let startDateTimestamp = this.getDateTimestamp(this.startDate);
        let endDateTimestamp = this.getDateTimestamp(this.endDate);

        this.buscar(startDateTimestamp, endDateTimestamp);
      });
    },
  },
};
</script>

<style scoped>
.v-input__slot {
  min-height: 30px !important;
  height: 42px !important;
}
</style>
